<template>
  <tr v-if="!editing">
    <td v-show="editable">
      <v-icon @click="editing = !editing">
        edit
      </v-icon>
    </td>
    <td class="punchStyle(punch) py-2">
      {{ punch.punchType }}
    </td>
    <td>
      {{ punch.punchTime | moment("dddd, MMMM D") }}
    </td>
    <td>
      {{ punch.punchTime | moment("h:mm a") }}
    </td>
    <td v-show="editable" class="text-xs-right">
      <v-dialog v-model="deleteEntryDialog" max-width="400">
        <v-icon slot="activator" @click="">
          delete
        </v-icon>
        <v-card>
          <v-card-text>
            <h2 class="headline">Are you sure?</h2>
            <p class="body">This will delete this clock entry and all data associated with it, including any IP address logged at the time.</p>
            <p class="body-2">{{ this.punch.punchType }} at {{ this.punch.punchTime | moment("h:mm a") }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" flat small @click="deleteEntryDialog = false">Nevermind</v-btn>
            <v-btn color="error" small @click="deleteEntry" :disabled="deleteCallPending" :loading="deleteCallPending">
              Yes, Delete it
            </v-btn>
          </v-card-actions>
          </v-card>
        </v-card>
      </v-dialog>
    </td>
  </tr>
  <tr v-else class="editing">
    <td class="py-1">
      <v-icon @click="editing = !editing">
        check
      </v-icon>
    </td>
    <td>
      <ApiField
        fieldType="autocomplete"
        :items="punchTypes"
        item-text="name"
        item-value="name"
        label="Punch Type"
        storeAction="timeclock/update"
        storeUpdate="timeclock/updatePunch"
        paramName="clock_entry"
        :object="punch"
        fieldName="punch_type"
        :storeFieldValue="punch.punchType"
      >
      </ApiField>
    </td>
    <td>
      <template>
        <v-flex>
          <v-menu
            ref="dateMenu"
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator" slot-scope="{ on }">
              <v-text-field
                label="Date"
                format="dddd, MM DD YYYY"
                @change="value => date = value"
                :value="dateFormatted"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" @input="dateMenu = false" no-title scrollable>
            </v-date-picker>
          </v-menu>
        </v-flex>
      </template>
    </td>
    <td>
      <v-layout row>
        <v-text-field
          style="width: 60px;"
          label="Hour"
          v-model="hour"
          ></v-text-field>
        <v-text-field
          style="width: 60px;"
          label="Minute"
          v-model="minute"
        ></v-text-field>
        <v-select
          style="width: 60px;"
          label="AM/PM"
          v-model="ampm"
          :items="ampmOptions"
          item-text="name"
          item-value="name"
        ></v-select>
        <!--
        <v-text-field
          v-model="offset"
          label="offset"
        ></v-text-field>
        -->
      </v-layout>
    </td>
    <td class="text-xs-right">
        <v-btn @click="saveTime" :disabled="apiCallPending" :loading="apiCallPending" color="success">
          Save
        </v-btn>
    </td>
  </tr>
</template>

<script>
import { mapState } from 'vuex'
import ApiField from '@/components/base/api-field.vue'

export default {
  props: [
    'punch',
    'editable',
  ],
  components: {
    ApiField,
  },
  computed: {
    // ...mapState('userAuth', [
    //   'user',
    // ]),
    dateFormatted: function () {
      return this.date ? this.$moment(this.date).format('dddd, MMMM D') : ''
    },
  },
  created () {
  },
  watch: {
  },
  data: function () {
    return {
      deleteEntryDialog: false,
      deleteCallPending: false,
      apiCallPending: false,
      offset: new Date().getTimezoneOffset() / 60,
      date: this.$moment(this.punch.punchTime).format('YYYY-MM-DD'),
      hour: this.$moment(this.punch.punchTime).format("h"),
      minute: this.$moment(this.punch.punchTime).format("mm"),
      ampm: this.$moment(this.punch.punchTime).format("a"),
      dateMenu: false,
      editing: false,
      punchTypes: [
        {
          name: "Shift Start",
        },
        {
          name: "Break Start",
        },
        {
          name: "Break End",
        },
        {
          name: "Final Shift End",
        },
      ],
      ampmOptions: [
        {
          name: 'am',
        },
        {
          name: 'pm',
        },
      ],
    }
  },
  methods: {
    deleteEntry () {
      this.deleteCallPending = true
      this.$store.dispatch('timeclock/destroy', this.punch.id)
      .then(res => {
        this.$store.dispatch('global/showSnackbarSuccess', { message: "Timeclock entry deleted!" })
      })
      .catch(err => {
        this.$store.dispatch('global/showSnackbarError', { message: "There was a problem deleting that entry..." })
        console.log(err)
      })
      .finally(res => {
        this.deleteCallPending = false
      })
    },
    saveTime () {
      this.apiCallPending = true
      const hour = this.hour
      const minute = this.minute
      const ampm = this.ampm
      const offset = this.offset
      this.$store.dispatch('timeclock/update', {
        id: this.punch.id,
        clock_entry: {
          datetime_with_offset: {
            date: this.date,
            time: `${ hour }:${ minute }${ampm}`,
            offset: offset,
          }
        }
      })
      .then(res => {
        this.$store.dispatch('global/showSnackbarSuccess', { message: "Timeclock entry updated!" })
      })
      .catch(err => {
        this.$store.dispatch('global/showSnackbarError', { message: "There was a problem updating that entry..." })
      })
      .finally(r => {
        this.apiCallPending = false
        this.editing = false
      })


    },
    punchStyle (punch) {
    },
  },
}
</script>

<style scoped>
  tr:not(.editing):hover {
    opacity: 0.7;
  }
</style>
